export const normalizujDane = (dane, showId = false) => {
    if (dane && dane[0] && typeof dane[0] === 'string') {
        return dane?.map((e) => ({
            value: e,
            label: e,
        }));
    }


    return dane?.map((e) => ({
        value: e.id,
        label: showId ? (e.id + ': ' + e.nazwa) : (e.nazwa || e.opis),
    }));
};